export const IMAGE_SLOTS = {
  'homepage-hero': {
    label: 'Homepage Hero',
    description: 'Right-side hero image on the home page',
  },
  'about-banner': {
    label: 'About Banner',
    description: 'Banner image on the Company/About page header',
  },
  'homepage-moveonfilm': {
    label: 'Move On Film Banner',
    description: 'Full-width background image for the #MOVEONFILM section on the home page',
  },
  'homepage-photoshoot': {
    label: 'Free Photoshoot Banner',
    description: 'Background photo for the "Free photoshoot each month" banner on the home page',
  },
  'homepage-quote': {
    label: 'Homepage Quote Banner',
    description: 'Background image for the testimonial quote banner on the home page',
  },
  'homepage-join': {
    label: 'Join One Day Dance',
    description: 'Image for the "Join One Day Dance" apply section on the home page',
  },
  'homepage-initiative-films': {
    label: 'Initiative Card — Films',
    description: 'Image for the Films initiative card on the home page',
  },
  'homepage-initiative-oddfest': {
    label: 'Initiative Card — ODDFEST',
    description: 'Image for the ODDFEST initiative card on the home page',
  },
  'homepage-initiative-shift': {
    label: 'Initiative Card — S.H.I.F.T.',
    description: 'Image for the S.H.I.F.T. initiative card on the home page',
  },
  'homepage-social-instagram': {
    label: 'Follow Us — Instagram',
    description: 'Background image for the Instagram pill in the homepage Follow Us section',
  },
  'homepage-social-youtube': {
    label: 'Follow Us — YouTube',
    description: 'Background image for the YouTube pill in the homepage Follow Us section',
  },
  'homepage-social-facebook': {
    label: 'Follow Us — Facebook',
    description: 'Background image for the Facebook pill in the homepage Follow Us section',
  },
  'homepage-social-email': {
    label: 'Follow Us — Email',
    description: 'Background image for the Email pill in the homepage Follow Us section',
  },
  'homepage-social-login': {
    label: 'Follow Us — Login',
    description: 'Background image for the Login pill in the homepage Follow Us section',
  },
  'sign-in-background': {
    label: 'Sign In Page Background',
    description: 'Full-page background image behind the sign-in form',
  },
  'connect-background': {
    label: 'Connect Page Background',
    description: 'Full-page background image behind the newsletter signup and social links on /connect',
  },
  'not-found-background': {
    label: '404 Page Background',
    description: 'Full-page background image behind the 404 / page-not-found content',
  },
} as const

export type SlotKey = keyof typeof IMAGE_SLOTS
